import gql from 'graphql-tag'

export const shiftTemplateFragment = gql`
    fragment shiftTemplateFragment on ShiftTemplate{
        id
        deleted_at
        name
        description
        
        start_time
        end_time

        Sun
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
    }
`

export const projectShiftFragment = gql`
    fragment projectShiftFragment on ProjectShift{
        id
        name
        description
        hasDraft
        
        start_time
        end_time
        dates{
            from
            to
        }

        Sun
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat

        isProjectShiftOverwriter
        overwrittenProjectShift{
            id
            name
        }
    }
`
export const shiftFragment = gql`
    fragment shiftFragment on Shift{
        id
        name
        description
        
        date
        dayOfWeek
        start_time
        end_time
        status
        isDraft
        draft_shift_id
        hasDraftShift
        project_shift_id

        isProjectShiftOverwriter
        overwrittenProjectShift{
            id
            name
        }
    }
`
export const draftShiftFragment = gql`
    fragment draftShiftFragment on DraftShift{
        id
        name
        description
        
        date
        dayOfWeek
        start_time
        end_time
        status
        isDraft
        project_shift_id

        isProjectShiftOverwriter
        overwrittenProjectShift{
            id
            name
        }
    }
`